import sanityClient from '@sanity/client'

export default sanityClient({
  projectId: 'wa3u0nkp',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2024-09-26', // Use the current date or the latest available version
})
